<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <b-button variant="secondary" class="ml-2" @click="$router.go(-1)">
          <i class="fas fa-arrow-left"></i> {{ $t('volver') }}
        </b-button>
        <div class="d-flex" style="gap:8px;">
          <b-button v-if="editMode && puedeEditarFicha" @click.prevent="submitForm" variant="primary">
            <i class="fas fa-save mr-1"></i> {{ $t('guardar') }}
          </b-button>
          <b-button v-if="editMode && !editPass && puedeEditarFicha" @click.prevent="editPass = !editPass;"
            :variant="!editPass ? 'info' : 'danger'">
            {{ editPass ? $t('cancelar') : $t('editar_contrasena') }}
          </b-button>
          <base-button v-if="puedeEditarFicha" :type="editMode ? 'danger' : 'warning'" @click="cancelEdit">
            {{ editMode ? $t('cancelar') : $t('editar') }}
          </base-button>
        </div>
      </div>

      <b-container style="max-width: 90%; margin: auto;">

        <b-card-header class="border-0">
          <h3 class="mb-0">{{ $t('informacion') }}</h3>
        </b-card-header>
        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="4">
              <b-form-group label-for="nombreContacto">
                <template v-slot:label>
                  {{ $t('nombre') }} <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="nombreContacto" v-model="usuario.nombre" required
                  :placeholder="$t('nombre_contacto_placeholder')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="apellidoContacto">
                <template v-slot:label>
                  {{ $t('apellido') }} <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="apellidoContacto" v-model="usuario.apellidoP" required
                  :placeholder="$t('apellido_contacto_placeholder')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="telefono">
                <template v-slot:label>
                  {{ $t('telefono') }} <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="telefono" v-model="usuario.telefono" required
                  :placeholder="$t('fono')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="correo">
                <template v-slot:label>
                  {{ $t('correo') }} <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="correo" v-model="usuario.correo" required
                  :placeholder="$t('correo')"></b-form-input>
              </b-form-group>
            </b-col>         
            <b-col md="4">
              <b-form-group label-for="Locacion">
                <template v-slot:label>
                  {{ $t('locacion') }} <span class="text-danger">*</span>
                </template>
                <b-form-select id="rolID" :disabled="!editMode" v-model="usuario.idPais" required>
                  <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                  <option v-for="option in opcionesPaises" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="idRol">
                <template v-slot:label>
                  {{ $t('rol') }} <span class="text-danger">*</span>
                </template>
                <b-form-select :disabled="!editMode" id="idRol" v-model="usuario.idRol" required>
                  <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                  <option v-for="option in rolesOptions" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :label="$t('estado')" label-for="activo">
                <b-form-select :disabled="!editMode || esCuentaPropia" id="activo" v-model="usuario.activo">
                  <option :value="true">{{ $t('activo') }}</option>
                  <option :value="false">{{ $t('inactivo') }}</option>
                </b-form-select>
                <small v-if="esCuentaPropia" class="text-muted">
                  {{ $t('no_cambiar_estado_propio') }}
                </small>
              </b-form-group>
            </b-col>
            <b-col v-if="usuario.idRol == 3" md="4">
              <b-form-group label-for="idZona">
                <template v-slot:label>
                  {{ $t('zona') }} <span class="text-danger">*</span>
                </template>
                <b-form-select :disabled="!editMode" id="idZona" v-model="usuario.idZona" required>
                  <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                  <option v-for="option in zonasOptions" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
            
            
          </b-row>   
          <b-row>
            <b-col v-if="editPass" md="4" class="ml-3 passw">
              <b-form-group label-for="correo">
                <template v-slot:label>
                  {{ $t('contrasena') }} <span class="text-danger">*</span>
                </template>
                <div class="input-group">
                  <b-form-input :disabled="!editMode" @blur="validatePassword" @change="validatePassword"
                    class="rounded-left" required :placeholder="$t('contrasena')"
                    :type="showPassword ? 'text' : 'password'" v-model="usuario.password"></b-form-input>
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary rounded-right" type="button"
                      @click="togglePassword">
                      <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </button>
                  </div>
                </div>
                <span v-if="passwordError" style="color: red; font-size: 12px;">{{$t('contrasena_caracteres')}}</span>
              </b-form-group>
            </b-col>
            <b-col v-if="editPass" md="4">
              <b-form-group label-for="correo">
                <template v-slot:label>
                  {{ $t('confirmar_contrasena') }} <span class="text-danger">*</span>
                </template>
                <div class="input-group">
                  <b-form-input :disabled="!editMode" @blur="validatePassword" @change="validatePassword"
                    class=" rounded-left" required :placeholder="$t('confirmar_contrasena')"
                    :type="showPassword ? 'text' : 'password'" v-model="password"></b-form-input>
                </div>
                <span v-if="passwordError2" style="color: red; font-size: 12px;">{{$t('contrasena_caracteres')}}</span>
                <span v-else-if="!passwordIgual" style="color: red; font-size: 12px;">{{$t('contrasena_iguales')}}</span>
              </b-form-group>
            </b-col> 
             </b-row>
          
          <!-- Sección de Empresas -->
          <b-row class="mt-4">
            <b-col md="12">
              <b-card-header class="border-0">
                <h3 class="mb-0">{{ $t('empresas') }}
                  <small class="text-muted ml-2" style="font-size:0.75rem;">
                    {{ empresasFiltradas.length }} / {{ empresasUsuario.length }}
                  </small>
                </h3>
              </b-card-header>
              <b-table-simple hover small responsive>
                <b-thead>
                  <b-tr>
                    <b-th class="th-ordenable" @click="sortEmpresasPor('nombre')">
                      <input class="th-search-input" v-model="filterEmpresa" @click.stop :placeholder="$t('buscar')" />
                      <span class="th-label">{{ $t('empresa') }} <i :class="iconoOrdenEmpresa('nombre')"></i></span>
                    </b-th>
                    <b-th class="th-ordenable" @click="sortEmpresasPor('pais')">
                      <input class="th-search-input" v-model="filterPais" @click.stop :placeholder="$t('buscar')" />
                      <span class="th-label">{{ $t('pais') || 'País' }} <i :class="iconoOrdenEmpresa('pais')"></i></span>
                    </b-th>
                    <b-th class="text-center" style="width:90px;">
                      <b-form-checkbox
                        :checked="todosVisiblesSeleccionados"
                        :disabled="!editMode || (limiteUnaEmpresa && empresasFiltradas.length > 1)"
                        @change="toggleTodosVisibles"
                        title="Seleccionar todos los visibles"
                      ></b-form-checkbox>
                      <div class="th-label">{{ $t('seleccionar') }}</div>
                    </b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="empresa in empresasFiltradas" :key="empresa.idEmpresa">
                    <b-td>{{ empresa.nombre }}</b-td>
                    <b-td>{{ empresa.pais || '-' }}</b-td>
                    <b-td class="text-center">
                      <b-form-checkbox
                        :checked="empresa.isCheck"
                        :disabled="!editMode"
                        @change="onEmpresaCheckChange(empresa, $event)"
                      ></b-form-checkbox>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-col>
          </b-row>

          <b-button v-if="editMode && puedeEditarFicha" type="submit" variant="primary" class="ml-3">
            {{ $t('guardar') }}
          </b-button>
        </b-form>
      </b-container>
    </base-header>
  </div>
</template>

<script>
import usuarioService from '@/api/userService';
import zonaService from '@/api/zonaService';
import empresaService from '@/api/empresaService';
import utilsService from '@/api/utilsService';
import paisService from '@/api/paisService';
import { Select, Option } from 'element-ui';
export default {
  name: 'UserDetails',
  components: {
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      usuario: {},
      password: '',
      showPassword: false,
      passwordError: false,
      passwordError2: false,
      passwordIgual: true,
      zonasOptions: [],
      rolesOptions: [],
      empresasUsuario: [],
      opcionesPaises: [],
      editPass: false,
      editMode: false,
      filterEmpresa: '',
      filterPais: '',
      sortColEmpresa: null,
      sortDirEmpresa: 'asc',
    };
  },
  computed: {
    rolActual() {
      return utilsService.getRol();
    },
    // El backend rechaza el cambio de estado sobre la propia cuenta,
    // para no dejarse fuera del sistema.
    esCuentaPropia() {
      return String(this.$route.params.id) === String(utilsService.getUserInfo().id);
    },
    // Los perfiles de solo lectura (ej. "visita") solo editan su propia cuenta:
    // el PUT del backend responde 403 sobre la ficha de cualquier otro usuario.
    puedeEditarFicha() {
      return this.puedeEscribir || this.esCuentaPropia;
    },
    empresasFiltradas() {
      let lista = this.empresasUsuario;
      if (this.filterEmpresa) lista = lista.filter(e => (e.nombre || '').toLowerCase().includes(this.filterEmpresa.toLowerCase()));
      if (this.filterPais)    lista = lista.filter(e => (e.pais || '').toLowerCase().includes(this.filterPais.toLowerCase()));
      if (this.sortColEmpresa) {
        lista = [...lista].sort((a, b) => {
          let vA = String(a[this.sortColEmpresa] || '').toLowerCase();
          let vB = String(b[this.sortColEmpresa] || '').toLowerCase();
          if (vA < vB) return this.sortDirEmpresa === 'asc' ? -1 : 1;
          if (vA > vB) return this.sortDirEmpresa === 'asc' ? 1 : -1;
          return 0;
        });
      }
      return lista;
    },
    todosVisiblesSeleccionados() {
      const visibles = this.empresasFiltradas;
      return visibles.length > 0 && visibles.every(e => e.isCheck);
    },
    rolNombreSeleccionado() {
      const opt = this.rolesOptions.find(r => r.value === this.usuario.idRol);
      return opt ? (opt.text || '').toLowerCase().trim() : '';
    },
    limiteUnaEmpresa() {
      return this.rolNombreSeleccionado === 'cliente' || this.rolNombreSeleccionado === 'comprador';
    },
  },
  async beforeMount() {
    const id = this.$route.params.id;
    this.usuario = await usuarioService.get(id);
    this.initData();
  },
  methods: {
    async initData() {
      const paises = await paisService.getAll();
      this.opcionesPaises = paises
        .map(p => ({ value: p.idPais, text: p.nombre }))
        .sort((a, b) => String(a.text || '').localeCompare(String(b.text || ''), 'es', { sensitivity: 'base' }));
      this.rolesOptions = await usuarioService.getRolesOptions();
      this.zonasOptions = await zonaService.getZonasOptions();
      
      // Cargar empresas del usuario
      const id = this.$route.params.id;
      this.empresasUsuario = await empresaService.getEmpresasByUsuario(id);

    },
    async cancelEdit() {
      if (this.editMode) {
        const id = this.$route.params.id;
        this.usuario = await usuarioService.get(id);
        await this.initData();
      }
      this.editMode = !this.editMode;
      this.editPass = false;

    },
    validatePassword() {
      if (this.usuario.password.length > 0) this.passwordError = this.usuario.password.length < 5;
      if (this.password.length > 0) this.passwordError2 = this.password.length < 5;
      if (this.usuario.password == this.password)
        this.passwordIgual = true;
      else
        this.passwordIgual = false;
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    toggleTodosVisibles(checked) {
      this.empresasFiltradas.forEach(e => { e.isCheck = checked; });
    },
    onEmpresaCheckChange(empresa, checked) {
      if (checked && this.limiteUnaEmpresa) {
        const otras = this.empresasUsuario.filter(e => e.idEmpresa !== empresa.idEmpresa && e.isCheck);
        if (otras.length) {
          otras.forEach(e => { e.isCheck = false; });
          this.$toast.error(this.$t('solo_una_empresa_permitida'));
        }
      }
      empresa.isCheck = checked;
    },
    sortEmpresasPor(col) {
      if (this.sortColEmpresa === col) {
        this.sortDirEmpresa = this.sortDirEmpresa === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColEmpresa = col;
        this.sortDirEmpresa = 'asc';
      }
    },
    iconoOrdenEmpresa(col) {
      if (this.sortColEmpresa !== col) return 'fas fa-sort text-muted';
      return this.sortDirEmpresa === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
    },
    async submitForm() {
      if (!this.puedeEditarFicha) return;
      if (this.passwordError == true || !this.passwordIgual) {
        this.$toast.error('Contraseña no válida.', {
          position: 'top-center',
          timeout: 2000,
          closeOnClick: true,
          pauseOnHover: true
        });
        return;
      }
      Swal.fire({
        title: this.$t('esta_seguro'),
        text: this.$t('verificar_datos_pregunta'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('actualizar'),
        cancelButtonText: this.$t('cancelar')
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            Swal.fire({
              html: `<div style="display: flex; align-items: center; justify-content: center;">
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('actualizando')}</h3>
                        </div>
                    </div>`,
              showConfirmButton: false,
              allowOutsideClick: false
            });
            const id = this.$route.params.id;
            // Configurar idEmpresa como 0 por defecto
            this.usuario.idEmpresa = 0;

            // Agregar empresas con el formato completo al payload
            this.usuario.empresas = this.empresasUsuario.map(empresa => ({
              idEmpresa: empresa.idEmpresa,
              nombre: empresa.nombre,
              isCheck: empresa.isCheck
            }));

            const response = await usuarioService.update(this.usuario, id);
            if (!response) {
              Swal.fire({ icon: "error", title: "Oops...", text: this.$t('error_desconocido') });
              return;
            }

            Swal.fire({
              title: this.$t('actualizado_correctamente'),
              icon: "success",
              showConfirmButton: false,
              timer: 2000
            });
            this.editMode = false;
            this.usuario = await usuarioService.get(id);

          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.message || this.$t('error_desconocido')
            });
          }
        }
        else if (result.isDenied) {
          Swal.close();
        }
      });
    }
  }
};
</script>

<style scoped>
.th-ordenable {
  cursor: pointer;
  user-select: none;
  vertical-align: top;
  white-space: nowrap;
}
.th-ordenable:hover {
  background-color: #e9ecef !important;
}
.th-search-input {
  width: 100%;
  font-size: 11px;
  padding: 2px 4px;
  border: 1px solid #ced4da;
  border-radius: 3px;
  margin-bottom: 3px;
  display: block;
  font-weight: normal;
}
.th-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
</style>
